<template>
  <div
    id="welcome-candidate"
    class="container"
  >
    <section class="section has-nav-top-margin">
      <div class="is-inline-block">
        <h4 class="title is-4">
          Welcome, {{ account.username }}!
        </h4>
        <p class="subtitle">
          You're one step closer to being discovered by top companies! Now let's create your
          <b>
            <i>Confidential Employment Profile.</i>
          </b>
        </p>
      </div>
    </section>
    <section
      v-if="!isLoading"
      class="section no-pad-top"
    >
      <profession-candidate @checkForm="checkForm" />
      <div class="has-text-centered">
        <p
          v-if="areErrorsShowing"
          class="help has-text-danger title is-7 has-text-weight-normal"
        >
          <span v-if="professionNameError">Profession is required.</span>
          <span v-if="professionYearsExperienceError">Years of experience is required.</span>
        </p>
        <button
          class="button is-rounded is-large is-primary has-text-weight-bold"
          @click="updateCandidateProfile()"
        >
          Create My Profile
        </button>
      </div>
    </section>
    <section
      v-else
      class="section"
    >
      <loading-spinner />
    </section>
  </div>
</template>

<script>
import ProfessionCandidate from '@/components/CandidateProfile/ProfessionCandidate';
import LoadingSpinner from '@/components/Utilities/LoadingSpinner';

export default {
  name: 'WelcomeCandidate',
  components: {
    'loading-spinner': LoadingSpinner,
    ProfessionCandidate
  },
  data () {
    return {
      isLoading: false,
      areErrorsShowing: false
    };
  },
  computed: {
    professionNameError () {
      return !this.profile.profession.name;
    },
    professionYearsExperienceError () {
      return !this.profile.profession.years_experience;
    },
    isFormValid () {
      return !this.professionNameError && !this.professionYearsExperienceError;
    },
    account: {
      get () {
        return this.$store.getters.getUserAccount;
      },
      set (newValue) {
        this.$store.state.user.account = newValue;
      }
    },
    profile: {
      get () {
        return this.$store.getters.getUserProfile;
      },
      set (newValue) {
        this.$store.state.user.profile = newValue;
      }
    }
  },
  created () {
    this.account = this.$store.getters.getUserAccount;
    this.profile = this.$store.getters.getUserProfile;
  },
  mounted () {
    this.checkForm();
  },
  updated () {
    this.checkForm();
  },
  methods: {
    updateCandidateProfile () {
      if (!this.profile.profession.name || !this.profile.profession.years_experience) {
        this.toggleErrors();
        this.checkForm();
      } else {
        this.isLoading = true;
        this.$emit('nextStep');
      }
    },
    checkForm () {
      setTimeout(() => {
        this.$emit('checkForm', this.isFormValid);
      }, 50);
    },
    toggleErrors () {
      this.areErrorsShowing = !this.areErrorsShowing;
    }
  }
};
</script>

<style scoped lang="scss">
#profession-candidate {
  margin-bottom: 4rem;
}

.welcome-container {
  padding: 3rem 1.5rem;
}

.button {
  margin: 0 0.5rem;
}

.button.is-small {
  margin-top: 0.75rem;
}
</style>
